import './scss/index.scss';

const EmissionGraphTemplate = {
    template(item, prefixString = '') {
        const {
            rating,
            label,
        } = item;

        // console.log('prefixString : ', prefixString);

        return `
            <div id='${prefixString}rating-${rating}' class='bar-item'>
                <span class='bar-label'>${label}</span>
                <span class='bar-unit-value'></span>
                <span class='bar-unit-label'></span>
                <span class='bar-arrow'></span>
            </div>
        `;
    },
};

export default EmissionGraphTemplate;
